module.exports = __webpack_public_path__ + "img/Brightness1Round.8b79d723.svg";